// extracted by mini-css-extract-plugin
module.exports = {"Bookmark_Details_Container":"BookmarkModalContent_Bookmark_Details_Container__26VIO"};